import React from 'react';

// Components
import { ButtonDropdown as ParentButtonDropdown, ButtonDropdownProps as ParentButtonDropdownProps } from '@ui/base-button-radix-dropdown';

// Types
export interface StyledButtonDropdownProps extends ParentButtonDropdownProps {}

// Styled components
export const StyledButtonDropdown: React.FC<StyledButtonDropdownProps> = ParentButtonDropdown;